var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.777 6.25a.75.75 0 01.609.31l2.512 3.48 3.572-3.57a.75.75 0 111.06 1.06l-3.742 3.741 3.82 5.29A.751.751 0 0117 17.75h-2.777a.751.751 0 01-.609-.31l-2.513-3.481-3.57 3.571a.75.75 0 11-1.061-1.06l3.74-3.742-3.818-5.289A.751.751 0 017 6.25h2.777zm4.829 10h.926l-6.137-8.5h-.927l6.137 8.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3a1 1 0 011 1v16a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h16zM4.5 19.5h15v-15h-15v15z",
    fill: "currentColor"
  })));
}
SvgX.displayName = 'X';
export default SvgX;